// src/components/UpgradeDialog.jsx
import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import PanelUpgrade from '../panels/PanelUpgrade';

export default function UpgradeDialog({
  open,
  onClose,
  onNavigate,
  projectId,
  childName,
  offers = [],
  upgradeContext = null,
  onUpgradeConfirmed,
}) {
  const handleComplete = () => {
    onClose?.();

    // Contextual upgrades are opened on top of the section that hit the limit.
    // Stay on that section so the parent can continue immediately after purchase.
    // A generic upgrade opened without section context returns to home.
    if (!upgradeContext?.source) {
      onNavigate?.('home');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent sx={{ p: { xs: 2.5, sm: 4 }, position: 'relative' }}>
        <IconButton
          onClick={onClose}
          size="small"
          aria-label="Close upgrade dialog"
          sx={{ position: 'absolute', top: 12, right: 12, color: 'text.secondary' }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <PanelUpgrade
          projectId={projectId}
          childName={childName}
          offers={offers}
          upgradeContext={upgradeContext}
          onUpgradeConfirmed={onUpgradeConfirmed}
          onComplete={handleComplete}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}
